const guideline = {
  guidelineId: 'RECIP10',
  guidelineName: 'RECIP 1.0',
  measurementTechnique: 'VOLUMETRIC',
  // maxNumberOfTargets: 0,
  // maxNumberOfTargetsPerOrgan: 0,
  measurableLongAxis: 0,
  measurableShortAxis: 0,
  measurableVolume: 0,
  measurableLongAxisOfLymphNode: 15,
  measurableShortAxisOfLymphNode: 15,
  measurableVolumeOfLymphNode: 0,
  measurableLongAxisOfNewLesion: 0,
  measurableShortAxisOfNewLesion: 0,
  measurableVolumeOfNewLesion: 0,
  minDiameterIncrease: 0,
  minDiameterDecrease: 0,
  minVolumeIncrease: 0.2,
  minVolumeDecrease: 0.3,
  smallDiameterChange: 0,
  smallVolumeChange: 0,
  absoluteDiameterChange: 0,
  absoluteSumOfDiameterChange: 0,
  absoluteVolumeChange: 0,
  absoluteSumOfVolumeChange: 0,
  longitudinalIncreaseRule: 'fromPrevious',
  longitudinalDecreaseRule: 'fromPrevious',
  longitudinalPriority: 'None',
  newLesionRule: 'fromBL',
};

export default guideline;
